export default {"src":"/_next/static/media/user_24.21092f23.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};